import PropTypes from 'prop-types';

const Bancomat = ({ color }) => (
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.625 4.79167H15.625M3.95833 8.95833H3.96667M7.29167 8.95833H8.95833M0.625 3.125C0.625 2.46196 0.888392 1.82607 1.35723 1.35723C1.82607 0.888392 2.46196 0.625 3.125 0.625H13.125C13.788 0.625 14.4239 0.888392 14.8928 1.35723C15.3616 1.82607 15.625 2.46196 15.625 3.125V9.79167C15.625 10.4547 15.3616 11.0906 14.8928 11.5594C14.4239 12.0283 13.788 12.2917 13.125 12.2917H3.125C2.46196 12.2917 1.82607 12.0283 1.35723 11.5594C0.888392 11.0906 0.625 10.4547 0.625 9.79167V3.125Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Bancomat.propTypes = {
  color: PropTypes.string,
};

Bancomat.defaultProps = {
  color: '#696F7C',
};

export default Bancomat;
